module.exports = __webpack_public_path__ + "static/green_divider_bottom-3d8f2c2e0bfaafae0741ca026406b34a.png";